import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_MCP_OAUTH_CONNECTIONS = `${ENDPOINT_BASE}/mcp-oauth-connections`
